/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
// Place the currency symbol before the price.
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Valley News',
    SITE_DESCRIPTION:
      'Job seeker: stop your job search. Get matched with thousands of quality jobs. Employers: stop paying for job posting. Post jobs for free and pay only to contact qualified candidates that meet your requirements',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/vn/logo.png',
      faviconsPath: '/static/vn',
    },
    OG_IMAGE: '/static/vn/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#121212',
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-979LQPKBHK'],
  },
});
